const SET_TOTAL_ALERTS = (state, totalAlertsData) => {
  state.totalAlertsData = totalAlertsData;
};

export default {
  SET_TOTAL_ALERTS
};



// WEBPACK FOOTER //
// ./src/store/modules/anomaly/mutations.js